import actions from './actions';

const {
  ONBOARDING_SESSION_BEGIN,
  ONBOARDING_SESSION_SUCCESS,
  ONBOARDING_SESSION_ERR,
  ONBOARDING_STEP_SAVE_BEGIN,
  ONBOARDING_STEP_SAVE_SUCCESS,
  ONBOARDING_STEP_SAVE_ERR,
  ONBOARDING_CHAT_BEGIN,
  ONBOARDING_CHAT_SUCCESS,
  ONBOARDING_CHAT_ERR,
  ONBOARDING_INITIATE_BEGIN,
  ONBOARDING_INITIATE_SUCCESS,
  ONBOARDING_INITIATE_ERR,
  ONBOARDING_VERIFY_BEGIN,
  ONBOARDING_VERIFY_SUCCESS,
  ONBOARDING_VERIFY_ERR,
  ONBOARDING_RESEND_BEGIN,
  ONBOARDING_RESEND_SUCCESS,
  ONBOARDING_RESEND_ERR,
  ONBOARDING_COMPLETE_BEGIN,
  ONBOARDING_COMPLETE_SUCCESS,
  ONBOARDING_COMPLETE_ERR,
  ONBOARDING_LOCAL_FAVE_ADD_BEGIN,
  ONBOARDING_LOCAL_FAVE_ADD_SUCCESS,
  ONBOARDING_LOCAL_FAVE_ADD_ERR,
  ONBOARDING_LOCAL_FAVE_UPDATE_BEGIN,
  ONBOARDING_LOCAL_FAVE_UPDATE_SUCCESS,
  ONBOARDING_LOCAL_FAVE_UPDATE_ERR,
  ONBOARDING_LOCAL_FAVE_DELETE_BEGIN,
  ONBOARDING_LOCAL_FAVE_DELETE_SUCCESS,
  ONBOARDING_LOCAL_FAVE_DELETE_ERR,
  ONBOARDING_LOCAL_FAVE_REORDER_BEGIN,
  ONBOARDING_LOCAL_FAVE_REORDER_SUCCESS,
  ONBOARDING_LOCAL_FAVE_REORDER_ERR,
  ONBOARDING_GUIDEBOOK_SECTION_SAVE_BEGIN,
  ONBOARDING_GUIDEBOOK_SECTION_SAVE_SUCCESS,
  ONBOARDING_GUIDEBOOK_SECTION_SAVE_ERR,
  ONBOARDING_SET_LISTING_THEME_BEGIN,
  ONBOARDING_SET_LISTING_THEME_SUCCESS,
  ONBOARDING_SET_LISTING_THEME_ERR,
  ONBOARDING_TRIGGER_LISTING_SYNC_BEGIN,
  ONBOARDING_TRIGGER_LISTING_SYNC_SUCCESS,
  ONBOARDING_TRIGGER_LISTING_SYNC_ERR,
  ONBOARDING_GUIDEBOOK_PREVIEW_BEGIN,
  ONBOARDING_GUIDEBOOK_PREVIEW_SUCCESS,
  ONBOARDING_GUIDEBOOK_PREVIEW_ERR,
  ONBOARDING_THEMES_BEGIN,
  ONBOARDING_THEMES_SUCCESS,
  ONBOARDING_THEMES_ERR,
  ONBOARDING_UPDATE_MSG_TEMPLATE_BEGIN,
  ONBOARDING_UPDATE_MSG_TEMPLATE_SUCCESS,
  ONBOARDING_UPDATE_MSG_TEMPLATE_ERR,
  ONBOARDING_ACTIVATE_MESSAGING_BEGIN,
  ONBOARDING_ACTIVATE_MESSAGING_SUCCESS,
  ONBOARDING_ACTIVATE_MESSAGING_ERR,
  ONBOARDING_GUIDEBOOK_STATUS_BEGIN,
  ONBOARDING_GUIDEBOOK_STATUS_SUCCESS,
  ONBOARDING_GUIDEBOOK_STATUS_ERR,
  ONBOARDING_DISCONNECT_PMS_BEGIN,
  ONBOARDING_DISCONNECT_PMS_SUCCESS,
  ONBOARDING_DISCONNECT_PMS_ERR,
  ONBOARDING_PMS_CONNECTION_STATUS_BEGIN,
  ONBOARDING_PMS_CONNECTION_STATUS_SUCCESS,
  ONBOARDING_PMS_CONNECTION_STATUS_ERR,
  ONBOARDING_CONNECT_PMS_CREDENTIALS_BEGIN,
  ONBOARDING_CONNECT_PMS_CREDENTIALS_SUCCESS,
  ONBOARDING_CONNECT_PMS_CREDENTIALS_ERR,
  ONBOARDING_SET_STEP_DRAFT,
} = actions;

const initState = {
  session: null,
  loading: false,
  chatLoading: false,
  error: null,
  stepDraft: {},
};

const OnboardingReducer = (state = initState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case ONBOARDING_SESSION_BEGIN:
    case ONBOARDING_STEP_SAVE_BEGIN:
    case ONBOARDING_INITIATE_BEGIN:
    case ONBOARDING_VERIFY_BEGIN:
    case ONBOARDING_RESEND_BEGIN:
    case ONBOARDING_COMPLETE_BEGIN:
      return { ...state, loading: true, error: null };

    case ONBOARDING_SESSION_SUCCESS:
      return { ...state, loading: false, session: data };

    case ONBOARDING_STEP_SAVE_SUCCESS:
    case ONBOARDING_INITIATE_SUCCESS:
    case ONBOARDING_VERIFY_SUCCESS:
    case ONBOARDING_RESEND_SUCCESS:
    case ONBOARDING_COMPLETE_SUCCESS:
      return { ...state, loading: false };

    case ONBOARDING_SESSION_ERR:
    case ONBOARDING_STEP_SAVE_ERR:
    case ONBOARDING_INITIATE_ERR:
    case ONBOARDING_VERIFY_ERR:
    case ONBOARDING_RESEND_ERR:
    case ONBOARDING_COMPLETE_ERR:
      return { ...state, loading: false, error: err };

    case ONBOARDING_CHAT_BEGIN:
      return { ...state, chatLoading: true, error: null };

    case ONBOARDING_CHAT_SUCCESS:
      return { ...state, chatLoading: false };

    case ONBOARDING_CHAT_ERR:
      return { ...state, chatLoading: false, error: err };

    case ONBOARDING_LOCAL_FAVE_ADD_BEGIN:
    case ONBOARDING_LOCAL_FAVE_UPDATE_BEGIN:
    case ONBOARDING_LOCAL_FAVE_DELETE_BEGIN:
    case ONBOARDING_LOCAL_FAVE_REORDER_BEGIN:
    case ONBOARDING_GUIDEBOOK_SECTION_SAVE_BEGIN:
      return { ...state, loading: true, error: null };

    case ONBOARDING_LOCAL_FAVE_ADD_SUCCESS:
    case ONBOARDING_LOCAL_FAVE_UPDATE_SUCCESS:
    case ONBOARDING_LOCAL_FAVE_DELETE_SUCCESS:
    case ONBOARDING_LOCAL_FAVE_REORDER_SUCCESS:
    case ONBOARDING_GUIDEBOOK_SECTION_SAVE_SUCCESS:
      return { ...state, loading: false };

    case ONBOARDING_LOCAL_FAVE_ADD_ERR:
    case ONBOARDING_LOCAL_FAVE_UPDATE_ERR:
    case ONBOARDING_LOCAL_FAVE_DELETE_ERR:
    case ONBOARDING_LOCAL_FAVE_REORDER_ERR:
    case ONBOARDING_GUIDEBOOK_SECTION_SAVE_ERR:
      return { ...state, loading: false, error: err };

    case ONBOARDING_SET_LISTING_THEME_BEGIN:
    case ONBOARDING_TRIGGER_LISTING_SYNC_BEGIN:
    case ONBOARDING_GUIDEBOOK_PREVIEW_BEGIN:
    case ONBOARDING_THEMES_BEGIN:
    case ONBOARDING_UPDATE_MSG_TEMPLATE_BEGIN:
    case ONBOARDING_ACTIVATE_MESSAGING_BEGIN:
    case ONBOARDING_GUIDEBOOK_STATUS_BEGIN:
    case ONBOARDING_DISCONNECT_PMS_BEGIN:
    case ONBOARDING_PMS_CONNECTION_STATUS_BEGIN:
    case ONBOARDING_CONNECT_PMS_CREDENTIALS_BEGIN:
      return { ...state, loading: true, error: null };

    case ONBOARDING_SET_LISTING_THEME_SUCCESS:
    case ONBOARDING_TRIGGER_LISTING_SYNC_SUCCESS:
    case ONBOARDING_GUIDEBOOK_PREVIEW_SUCCESS:
    case ONBOARDING_THEMES_SUCCESS:
    case ONBOARDING_UPDATE_MSG_TEMPLATE_SUCCESS:
    case ONBOARDING_ACTIVATE_MESSAGING_SUCCESS:
    case ONBOARDING_GUIDEBOOK_STATUS_SUCCESS:
    case ONBOARDING_DISCONNECT_PMS_SUCCESS:
    case ONBOARDING_PMS_CONNECTION_STATUS_SUCCESS:
    case ONBOARDING_CONNECT_PMS_CREDENTIALS_SUCCESS:
      return { ...state, loading: false };

    case ONBOARDING_SET_LISTING_THEME_ERR:
    case ONBOARDING_TRIGGER_LISTING_SYNC_ERR:
    case ONBOARDING_GUIDEBOOK_PREVIEW_ERR:
    case ONBOARDING_THEMES_ERR:
    case ONBOARDING_UPDATE_MSG_TEMPLATE_ERR:
    case ONBOARDING_ACTIVATE_MESSAGING_ERR:
    case ONBOARDING_GUIDEBOOK_STATUS_ERR:
    case ONBOARDING_DISCONNECT_PMS_ERR:
    case ONBOARDING_PMS_CONNECTION_STATUS_ERR:
    case ONBOARDING_CONNECT_PMS_CREDENTIALS_ERR:
      return { ...state, loading: false, error: err };

    case ONBOARDING_SET_STEP_DRAFT:
      return {
        ...state,
        stepDraft: {
          ...state.stepDraft,
          [action.slug]: {
            ...(state.stepDraft[action.slug] || {}),
            ...action.data,
          },
        },
      };

    default:
      return state;
  }
};

export default OnboardingReducer;
